import { render, staticRenderFns } from "./SupportCenterReport.vue?vue&type=template&id=6a2008ac"
import script from "./SupportCenterReport.vue?vue&type=script&lang=js"
export * from "./SupportCenterReport.vue?vue&type=script&lang=js"
import style0 from "./SupportCenterReport.vue?vue&type=style&index=0&id=6a2008ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports